import React from 'react';
import { useTranslation } from 'react-i18next';

import FrameContent from '../../components/custom frames/FrameContent';
import FrameWithButton from '../../components/custom frames/FrameWithButton';
import FrameContentTop from '../../components/custom frames/FrameContentTop';
import FrameImage from '../../components/frameImage';
import FrameContentBottom from '../../components/custom frames/FrameContentBottom';
import { homeImage } from '../../components/image-router';
import VideoCarousel from '../../components/VideoCarousel';

const Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <FrameImage image={homeImage} section="home" />
      <FrameContentTop></FrameContentTop>
      <FrameWithButton
        style={"frame-home-yellow"}
        title={t('home.needHelp')}
        subtitle={t('home.completeForm')}
        buttonTitle={t('home.applicationButton')}
        buttonLink={"/applicationForm"}
      ></FrameWithButton>
      {/* <FrameContent></FrameContent> */}
      <VideoCarousel/>
      <FrameWithButton
        style={"frame-home-yellow-2"}
        title={t('home.upcomingActivities')}
        subtitle={t('home.upcomingDescription')}
        buttonTitle={t('home.volunteerButton')}
        buttonLink={"/volunteerForm"}
      ></FrameWithButton>
      <FrameContentBottom
        style={"frame-bottom-content"}
        title={t('home.wantToHelp')}
        message={t('home.contactToDonate')}
        buttonTitle={t('home.donateThings')}
        subtitle={t('home.tellUsWhatToDonate')}
        bottom={t('home.address')}
        buttonLink={"/howHelp"}
      ></FrameContentBottom>
    </>
  );
};

Home.propTypes = {};

export default Home;
